import { useState } from 'react';
import { useNavigate } from 'react-router';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import CreateWorkflow from '../workflow/CreateWorkflow';
import { TimezoneSelector } from './timezone';

export default function GlobalSettingsPage() {
  const navigate = useNavigate();
  const [showCreateWorkflow, setShowCreateWorkflow] = useState(false);

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Typography variant="h4">
          Global Settings
        </Typography>
        <TimezoneSelector />
      </Stack>

      <Stack spacing={3} direction="row" alignItems="flex-start">
        <Card sx={{ p: 4, maxWidth: 500 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Manage Banner Alerts
          </Typography>

          <Card sx={{ p: 4, textAlign: 'center' }}>
            <Typography sx={{ color: 'text.secondary', mb: 3 }}>
              Create alerts and informational banners to display important information to users.
            </Typography>

            <Stack spacing={2} direction="column" alignItems="center">
              <Button
                variant="outlined"
                color="primary"
                onClick={() => navigate('/banners/view')}
                sx={{ width: 220 }}
              >
                Manage Banners
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={() => navigate('/banners/create')}
                sx={{ width: 220 }}
              >
                + Create Banner Alert
              </Button>
            </Stack>
          </Card>
        </Card>

        <Card sx={{ p: 4, maxWidth: 500 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Manage Workflows
          </Typography>

          <Card sx={{ p: 4, textAlign: 'center' }}>
            <Typography sx={{ color: 'text.secondary', mb: 3 }}>
              Create and manage vendor workflows to control the sequence and configuration of automated valuation models.
            </Typography>

            <Stack spacing={2} direction="column" alignItems="center">
              <Button
                variant="outlined"
                color="primary"
                onClick={() => navigate('/workflow')}
                sx={{ width: 220 }}
              >
                Manage Workflows
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={() => setShowCreateWorkflow(true)}
                sx={{ width: 220 }}
              >
                + Create New Workflow
              </Button>
            </Stack>
          </Card>
        </Card>
      </Stack>

      {showCreateWorkflow && (
        <CreateWorkflow
          mode="create"
          onClose={() => setShowCreateWorkflow(false)}
          onSuccess={() => navigate('/workflow')}
        />
      )}
    </Box>
  );
}
